import $ from "jquery";
$(() => {
    console.log("test");
});
